import { Button, FilterIcon } from 'canoe';
import React from 'react';
import { useDispatch } from 'react-redux';

import { setToggleIsAddingFilter } from './state';

export const AddFilter = () => {
  const dispatch = useDispatch();

  return (
    <Button appearance="text" icon={FilterIcon} onClick={() => dispatch(setToggleIsAddingFilter())}>
      Add Filter
    </Button>
  );
};
